import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            热门榜单
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            本周最受欢迎国产影视作品排行榜
          </p>
        </div>

        <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
          {rankingData.map((item, index) => (
            <a
              key={item.rank}
              href="#carousel"
              className={`flex items-center gap-4 p-4 md:p-5 hover:bg-primary-50/50 transition-colors duration-200 cursor-pointer ${
                index < rankingData.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div
                className={`flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-lg text-sm font-bold whitespace-nowrap ${
                  item.rank === 1
                    ? 'bg-accent-500 text-white'
                    : item.rank === 2
                    ? 'bg-accent-400 text-white'
                    : item.rank === 3
                    ? 'bg-accent-300 text-accent-900'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">{item.title}</h3>
                  <span className="px-1.5 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded whitespace-nowrap">{item.type}</span>
                  <span className="text-xs text-accent-600 font-medium whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="flex-shrink-0 flex items-center gap-1">
                <span className="text-lg font-bold text-accent-500 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>{item.score}</span>
                <span className="text-xs text-foreground-400">分</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}